<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <router-link
        style="text-decoration: none"
        :to="{
          name: ACTIONPLAN_ACTIONS_ITEM_ROUTE_NAME,
          params: { actionplanId: actionplanId, actionId: actionId },
        }"
      >
        <v-chip v-on="on" small v-bind="$attrs" style="cursor: pointer;">
          N°{{ actionId }}
        </v-chip>
      </router-link>
    </template>
    <span>
      {{ generateMessage('actions.item.link') }}
    </span>
  </v-tooltip>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import { ACTIONPLAN_ACTIONS_ITEM_ROUTE_NAME } from '@/router/actions.router';

export default {
  name: 'LinkToAction',
  props: {
    actionplanId: {
      type: [Number, String],
      required: true,
    },
    actionId: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    ACTIONPLAN_ACTIONS_ITEM_ROUTE_NAME,
  }),
  methods: {
    generateMessage,
  },
};
</script>
